import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { ConfigCotacaoItemFormularioIndicadorPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ConfigCotacaoItemFormularioIndicadorPipe
    ],
    exports: [
        ConfigCotacaoItemFormularioIndicadorPipe
    ],
    providers: [
        ConfigCotacaoItemFormularioIndicadorPipe
    ]
})
export class ConfigCotacaoModule { }
